import { Snackbar } from "@material-ui/core";
import React, { useContext } from "react";
import CloseIcon from "@material-ui/icons/Close";
import { DashboardContext } from "../../context/DashboardContext";
import { useStyles } from "./Snackbar.styles";

const SnackBar = () => {
  const classes = useStyles();
  const {
    _setEnableSnackBar,
    enableSnackbar,
    alertMessage,
  } = useContext(DashboardContext);

  return (
    <Snackbar
      open={enableSnackbar}
      className={classes.root}
      autoHideDuration={5000}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      onClose={() => {
        _setEnableSnackBar(false);
      }}
      disableWindowBlurListener={true}
      message={alertMessage}
      action={
        <CloseIcon
          className={classes.closeIcon}
          onClick={() => {
            _setEnableSnackBar(false);
          }}
        />
      }
    />
  );
};

export default SnackBar;
